import React, { Component } from "react";
import BaseLayout from "./../../templates/base";
import Loading from "../../elements/loading";
import TracingDispersionsForm from './../../elements/tracing/dispersions';

class TracingDispersions extends Component {
	render () {
		let { dispersions } = this.props;
		return (
			dispersions.isFetching ? <Loading />:<TracingDispersionsForm {...this.props}/>
		)
	}

	componentWillMount() {
		let {modality,state,municipality} = this.props.match.params;
		this.props.projectDispersions(modality, state, municipality);
		//this.props.fetchAgency(modality, state, municipality);
		//this.props.fetchOwner(modality, state, municipality);
		//this.props.projectRegistryData(modality, state, municipality);
		//this.props.fetchRevisions(modality, state, municipality);
	}

	componentWillReceiveProps(nextprops) {
		if(nextprops.match.params !== this.props.match.params) {
			let {modality, state, municipality} = nextprops.match.params;
			this.props.projectDispersions(modality, state, municipality);
			//this.props.fetchAgency(modality, state, municipality);
			//this.props.fetchOwner(modality, state, municipality);
			//this.props.projectRegistryData(modality, state, municipality);
			//this.props.fetchRevisions(modality, state, municipality);
		}
	}
}

export default BaseLayout(TracingDispersions, {
	title: 'Seguimiento Convenio Gubernatura',
	subnav:{
		icon: 'fa-exchange',
		name: 'Convenios'
	},
	stateNav: true
});


// WEBPACK FOOTER //
// ./src/layouts/tracing/dispersions.jsx